import { ReactNode } from 'react';
import { Box, Container, AppBar, Toolbar, Typography, CssBaseline } from '@mui/material';
import RocketLaunchIcon from '@mui/icons-material/RocketLaunch';

interface AppLayoutProps {
  children: ReactNode;
}

export const AppLayout = ({ children }: AppLayoutProps) => {
  return (
    <Box sx={{ display: 'flex', flexDirection: 'column', minHeight: '100vh' }}>
      <CssBaseline />

      {/* App Bar */}
      <AppBar position="sticky" elevation={0}>
        <Toolbar>
          <RocketLaunchIcon sx={{ mr: 2 }} />
          <Typography variant="h6" component="h1" sx={{ flexGrow: 1 }}>
            Eve Echoes Industry Calculator
          </Typography>
        </Toolbar>
      </AppBar>

      {/* Main Content */}
      <Container
        maxWidth="xl"
        sx={{
          flex: 1,
          py: 4,
          display: 'flex',
          flexDirection: 'column',
        }}
      >
        {children}
      </Container>

      {/* Footer */}
      <Box
        component="footer"
        sx={{
          py: 2,
          px: 2,
          mt: 'auto',
          textAlign: 'center',
          borderTop: (theme) => `1px solid ${theme.palette.divider}`,
        }}
      >
        <Typography variant="body2" color="text.secondary">
          Eve Echoes Industry Calculator - Data from echoes.mobi
        </Typography>
      </Box>
    </Box>
  );
};
